import './guidesail.css'
let F = {};
function D(e = {}) {
  F = {
    animate: !0,
    allowClose: !0,
    overlayOpacity: 0.7,
    smoothScroll: !1,
    disableActiveInteraction: !1,
    showProgress: !1,
    stagePadding: 10,
    stageRadius: 5,
    popoverOffset: 10,
    showButtons: ["next", "previous", "close"],
    disableButtons: [],
    overlayColor: "#000",
    ...e
  };
}
function a(e) {
  return e ? F[e] : F;
}
function W(e, o, t, i) {
  return (e /= i / 2) < 1 ? t / 2 * e * e + o : -t / 2 * (--e * (e - 2) - 1) + o;
}
function Q(e) {
  const o = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])';
  return e.flatMap((t) => {
    const i = t.matches(o), p = Array.from(t.querySelectorAll(o));
    return [...i ? [t] : [], ...p];
  }).filter((t) => getComputedStyle(t).pointerEvents !== "none" && ae(t));
}
function Z(e) {
  if (!e || se(e))
    return;
  const o = a("smoothScroll");
  e.scrollIntoView({
    // Removing the smooth scrolling for elements which exist inside the scrollable parent
    // This was causing the highlight to not properly render
    behavior: !o || re(e) ? "auto" : "smooth",
    inline: "center",
    block: "center"
  });
}
function re(e) {
  if (!e || !e.parentElement)
    return;
  const o = e.parentElement;
  return o.scrollHeight > o.clientHeight;
}
function se(e) {
  const o = e.getBoundingClientRect();
  return o.top >= 0 && o.left >= 0 && o.bottom <= (window.innerHeight || document.documentElement.clientHeight) && o.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function ae(e) {
  return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
}
let O = {};
function b(e, o) {
  O[e] = o;
}
function l(e) {
  return e ? O[e] : O;
}
function V() {
  O = {};
}
let R = {};
function N(e, o) {
  R[e] = o;
}
function L(e) {
  var o;
  (o = R[e]) == null || o.call(R);
}
function ce() {
  R = {};
}
function le(e, o, t, i) {
  let p = l("__activeStagePosition");
  const n = p || t.getBoundingClientRect(), f = i.getBoundingClientRect(), w = W(e, n.x, f.x - n.x, o), r = W(e, n.y, f.y - n.y, o), v = W(e, n.width, f.width - n.width, o), s = W(e, n.height, f.height - n.height, o);
  p = {
    x: w,
    y: r,
    width: v,
    height: s
  }, J(p), b("__activeStagePosition", p);
}
function G(e) {
  if (!e)
    return;
  const o = e.getBoundingClientRect(), t = {
    x: o.x,
    y: o.y,
    width: o.width,
    height: o.height
  };
  b("__activeStagePosition", t), J(t);
}
function de() {
  const e = l("__activeStagePosition"), o = l("__overlaySvg");
  if (!e)
    return;
  if (!o) {
    console.warn("No stage svg found.");
    return;
  }
  const t = window.innerWidth, i = window.innerHeight;
  o.setAttribute("viewBox", `0 0 ${t} ${i}`);
}
function pe(e) {
  const o = ue(e);
  document.body.appendChild(o), te(o, (t) => {
    t.target.tagName === "path" && L("overlayClick");
  }), b("__overlaySvg", o);
}
function J(e) {
  const o = l("__overlaySvg");
  if (!o) {
    pe(e);
    return;
  }
  const t = o.firstElementChild;
  if ((t == null ? void 0 : t.tagName) !== "path")
    throw new Error("no path element found in stage svg");
  t.setAttribute("d", U(e));
}
function ue(e) {
  const o = window.innerWidth, t = window.innerHeight, i = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  i.classList.add("driver-overlay", "driver-overlay-animated"), i.setAttribute("viewBox", `0 0 ${o} ${t}`), i.setAttribute("xmlSpace", "preserve"), i.setAttribute("xmlnsXlink", "http://www.w3.org/1999/xlink"), i.setAttribute("version", "1.1"), i.setAttribute("preserveAspectRatio", "xMinYMin slice"), i.style.fillRule = "evenodd", i.style.clipRule = "evenodd", i.style.strokeLinejoin = "round", i.style.strokeMiterlimit = "2", i.style.zIndex = "10000", i.style.position = "fixed", i.style.top = "0", i.style.left = "0", i.style.width = "100%", i.style.height = "100%";
  const p = document.createElementNS("http://www.w3.org/2000/svg", "path");
  return p.setAttribute("d", U(e)), p.style.fill = a("overlayColor") || "rgb(0,0,0)", p.style.opacity = `${a("overlayOpacity")}`, p.style.pointerEvents = "auto", p.style.cursor = "auto", i.appendChild(p), i;
}
function U(e) {
  const o = window.innerWidth, t = window.innerHeight, i = a("stagePadding") || 0, p = a("stageRadius") || 0, n = e.width + i * 2, f = e.height + i * 2, w = Math.min(p, n / 2, f / 2), r = Math.floor(Math.max(w, 0)), v = e.x - i + r, s = e.y - i, c = n - r * 2, d = f - r * 2;
  return `M${o},0L0,0L0,${t}L${o},${t}L${o},0Z
    M${v},${s} h${c} a${r},${r} 0 0 1 ${r},${r} v${d} a${r},${r} 0 0 1 -${r},${r} h-${c} a${r},${r} 0 0 1 -${r},-${r} v-${d} a${r},${r} 0 0 1 ${r},-${r} z`;
}
function ve() {
  const e = l("__overlaySvg");
  e && e.remove();
}
function fe() {
  const e = document.getElementById("driver-dummy-element");
  if (e)
    return e;
  let o = document.createElement("div");
  return o.id = "driver-dummy-element", o.style.width = "0", o.style.height = "0", o.style.pointerEvents = "none", o.style.opacity = "0", o.style.position = "fixed", o.style.top = "50%", o.style.left = "50%", document.body.appendChild(o), o;
}
function K(e) {
  const { element: o } = e;
  let t = typeof o == "string" ? document.querySelector(o) : o;
  t || (t = fe()), ge(t, e);
}
function he() {
  const e = l("__activeElement"), o = l("__activeStep");
  e && (G(e), de(), ie(e, o));
}
function ge(e, o) {
  const i = Date.now(), p = l("__activeStep"), n = l("__activeElement") || e, f = !n || n === e, w = e.id === "driver-dummy-element", r = n.id === "driver-dummy-element", v = a("animate"), s = o.onHighlightStarted || a("onHighlightStarted"), c = (o == null ? void 0 : o.onHighlighted) || a("onHighlighted"), d = (p == null ? void 0 : p.onDeselected) || a("onDeselected"), m = a(), g = l();
  !f && d && d(r ? void 0 : n, p, {
    config: m,
    state: g
  }), s && s(w ? void 0 : e, o, {
    config: m,
    state: g
  });
  const u = !f && v;
  let h = !1;
  xe(), b("previousStep", p), b("previousElement", n), b("activeStep", o), b("activeElement", e);
  const P = () => {
    if (l("__transitionCallback") !== P)
      return;
    const x = Date.now() - i, y = 400 - x <= 400 / 2;
    o.popover && y && !h && u && (X(e, o), h = !0), a("animate") && x < 400 ? le(x, 400, n, e) : (G(e), c && c(w ? void 0 : e, o, {
      config: a(),
      state: l()
    }), b("__transitionCallback", void 0), b("__previousStep", p), b("__previousElement", n), b("__activeStep", o), b("__activeElement", e)), window.requestAnimationFrame(P);
  };
  b("__transitionCallback", P), window.requestAnimationFrame(P), Z(e), !u && o.popover && X(e, o), n.classList.remove("driver-active-element", "driver-no-interaction"), n.removeAttribute("aria-haspopup"), n.removeAttribute("aria-expanded"), n.removeAttribute("aria-controls"), a("disableActiveInteraction") && e.classList.add("driver-no-interaction"), e.classList.add("driver-active-element"), e.setAttribute("aria-haspopup", "dialog"), e.setAttribute("aria-expanded", "true"), e.setAttribute("aria-controls", "driver-popover-content");
}
function we() {
  var e;
  (e = document.getElementById("driver-dummy-element")) == null || e.remove(), document.querySelectorAll(".driver-active-element").forEach((o) => {
    o.classList.remove("driver-active-element", "driver-no-interaction"), o.removeAttribute("aria-haspopup"), o.removeAttribute("aria-expanded"), o.removeAttribute("aria-controls");
  });
}
function I() {
  const e = l("__resizeTimeout");
  e && window.cancelAnimationFrame(e), b("__resizeTimeout", window.requestAnimationFrame(he));
}
function me(e) {
  var r;
  if (!l("isInitialized") || !(e.key === "Tab" || e.keyCode === 9))
    return;
  const i = l("__activeElement"), p = (r = l("popover")) == null ? void 0 : r.wrapper, n = Q([
    ...p ? [p] : [],
    ...i ? [i] : []
  ]), f = n[0], w = n[n.length - 1];
  if (e.preventDefault(), e.shiftKey) {
    const v = n[n.indexOf(document.activeElement) - 1] || w;
    v == null || v.focus();
  } else {
    const v = n[n.indexOf(document.activeElement) + 1] || f;
    v == null || v.focus();
  }
}
function ee(e) {
  var t;
  ((t = a("allowKeyboardControl")) == null || t) && (e.key === "Escape" ? L("escapePress") : e.key === "ArrowRight" ? L("arrowRightPress") : e.key === "ArrowLeft" && L("arrowLeftPress"));
}
function te(e, o, t) {
  const i = (n, f) => {
    const w = n.target;
    e.contains(w) && ((!t || t(w)) && (n.preventDefault(), n.stopPropagation(), n.stopImmediatePropagation()), f == null || f(n));
  };
  document.addEventListener("pointerdown", i, !0), document.addEventListener("mousedown", i, !0), document.addEventListener("pointerup", i, !0), document.addEventListener("mouseup", i, !0), document.addEventListener(
    "click",
    (n) => {
      i(n, o);
    },
    !0
  );
}
function ye() {
  window.addEventListener("keyup", ee, !1), window.addEventListener("keydown", me, !1), window.addEventListener("resize", I), window.addEventListener("scroll", I);
}
function be() {
  window.removeEventListener("keyup", ee), window.removeEventListener("resize", I), window.removeEventListener("scroll", I);
}
function xe() {
  const e = l("popover");
  e && (e.wrapper.style.display = "none");
}
function X(e, o) {
  var C, y;
  let t = l("popover");
  t && document.body.removeChild(t.wrapper), t = Pe(), document.body.appendChild(t.wrapper);
  const {
    title: i,
    description: p,
    showButtons: n,
    disableButtons: f,
    showProgress: w,
    nextBtnText: r = a("nextBtnText") || "Next &rarr;",
    prevBtnText: v = a("prevBtnText") || "&larr; Previous",
    progressText: s = a("progressText") || "{current} of {total}"
  } = o.popover || {};
  t.nextButton.innerHTML = r, t.previousButton.innerHTML = v, t.progress.innerHTML = s, i ? (t.title.innerHTML = i, t.title.style.display = "block") : t.title.style.display = "none", p ? (t.description.innerHTML = p, t.description.style.display = "block") : t.description.style.display = "none";
  const c = n || a("showButtons"), d = w || a("showProgress") || !1, m = (c == null ? void 0 : c.includes("next")) || (c == null ? void 0 : c.includes("previous")) || d;
  t.closeButton.style.display = c.includes("close") ? "block" : "none", m ? (t.footer.style.display = "flex", t.progress.style.display = d ? "block" : "none", t.nextButton.style.display = c.includes("next") ? "block" : "none", t.previousButton.style.display = c.includes("previous") ? "block" : "none") : t.footer.style.display = "none";
  const g = f || a("disableButtons") || [];
  g != null && g.includes("next") && (t.nextButton.disabled = !0, t.nextButton.classList.add("driver-popover-btn-disabled")), g != null && g.includes("previous") && (t.previousButton.disabled = !0, t.previousButton.classList.add("driver-popover-btn-disabled")), g != null && g.includes("close") && (t.closeButton.disabled = !0, t.closeButton.classList.add("driver-popover-btn-disabled"));
  const u = t.wrapper;
  u.style.display = "block", u.style.left = "", u.style.top = "", u.style.bottom = "", u.style.right = "", u.id = "driver-popover-content", u.setAttribute("role", "dialog"), u.setAttribute("aria-labelledby", "driver-popover-title"), u.setAttribute("aria-describedby", "driver-popover-description");
  const h = t.arrow;
  h.className = "driver-popover-arrow";
  const P = ((C = o.popover) == null ? void 0 : C.popoverClass) || a("popoverClass") || "";
  u.className = `driver-popover ${P}`.trim(), te(
    t.wrapper,
    (k) => {
      var $, B, M;
      const T = k.target, E = (($ = o.popover) == null ? void 0 : $.onNextClick) || a("onNextClick"), A = ((B = o.popover) == null ? void 0 : B.onPrevClick) || a("onPrevClick"), H = ((M = o.popover) == null ? void 0 : M.onCloseClick) || a("onCloseClick");
      if (T.classList.contains("driver-popover-next-btn"))
        return E ? E(e, o, {
          config: a(),
          state: l()
        }) : L("nextClick");
      if (T.classList.contains("driver-popover-prev-btn"))
        return A ? A(e, o, {
          config: a(),
          state: l()
        }) : L("prevClick");
      if (T.classList.contains("driver-popover-close-btn"))
        return H ? H(e, o, {
          config: a(),
          state: l()
        }) : L("closeClick");
    },
    (k) => !(t != null && t.description.contains(k)) && !(t != null && t.title.contains(k)) && typeof k.className == "string" && k.className.includes("driver-popover")
  ), b("popover", t);
  const S = ((y = o.popover) == null ? void 0 : y.onPopoverRender) || a("onPopoverRender");
  S && S(t, {
    config: a(),
    state: l()
  }), ie(e, o), Z(u);
  const _ = e.classList.contains("driver-dummy-element"), x = Q([u, ..._ ? [] : [e]]);
  x.length > 0 && x[0].focus();
}
function oe() {
  const e = l("popover");
  if (!(e != null && e.wrapper))
    return;
  const o = e.wrapper.getBoundingClientRect(), t = a("stagePadding") || 0, i = a("popoverOffset") || 0;
  return {
    width: o.width + t + i,
    height: o.height + t + i,
    realWidth: o.width,
    realHeight: o.height
  };
}
function Y(e, o) {
  const { elementDimensions: t, popoverDimensions: i, popoverPadding: p, popoverArrowDimensions: n } = o;
  return e === "start" ? Math.max(
    Math.min(
      t.top - p,
      window.innerHeight - i.realHeight - n.width
    ),
    n.width
  ) : e === "end" ? Math.max(
    Math.min(
      t.top - (i == null ? void 0 : i.realHeight) + t.height + p,
      window.innerHeight - (i == null ? void 0 : i.realHeight) - n.width
    ),
    n.width
  ) : e === "center" ? Math.max(
    Math.min(
      t.top + t.height / 2 - (i == null ? void 0 : i.realHeight) / 2,
      window.innerHeight - (i == null ? void 0 : i.realHeight) - n.width
    ),
    n.width
  ) : 0;
}
function j(e, o) {
  const { elementDimensions: t, popoverDimensions: i, popoverPadding: p, popoverArrowDimensions: n } = o;
  return e === "start" ? Math.max(
    Math.min(
      t.left - p,
      window.innerWidth - i.realWidth - n.width
    ),
    n.width
  ) : e === "end" ? Math.max(
    Math.min(
      t.left - (i == null ? void 0 : i.realWidth) + t.width + p,
      window.innerWidth - (i == null ? void 0 : i.realWidth) - n.width
    ),
    n.width
  ) : e === "center" ? Math.max(
    Math.min(
      t.left + t.width / 2 - (i == null ? void 0 : i.realWidth) / 2,
      window.innerWidth - (i == null ? void 0 : i.realWidth) - n.width
    ),
    n.width
  ) : 0;
}
function ie(e, o) {
  const t = l("popover");
  if (!t)
    return;
  const { align: i = "start", side: p = "left" } = (o == null ? void 0 : o.popover) || {}, n = i, f = e.id === "driver-dummy-element" ? "over" : p, w = a("stagePadding") || 0, r = oe(), v = t.arrow.getBoundingClientRect(), s = e.getBoundingClientRect(), c = s.top - r.height;
  let d = c >= 0;
  const m = window.innerHeight - (s.bottom + r.height);
  let g = m >= 0;
  const u = s.left - r.width;
  let h = u >= 0;
  const P = window.innerWidth - (s.right + r.width);
  let S = P >= 0;
  const _ = !d && !g && !h && !S;
  let x = f;
  if (f === "top" && d ? S = h = g = !1 : f === "bottom" && g ? S = h = d = !1 : f === "left" && h ? S = d = g = !1 : f === "right" && S && (h = d = g = !1), f === "over") {
    const C = window.innerWidth / 2 - r.realWidth / 2, y = window.innerHeight / 2 - r.realHeight / 2;
    t.wrapper.style.left = `${C}px`, t.wrapper.style.right = "auto", t.wrapper.style.top = `${y}px`, t.wrapper.style.bottom = "auto";
  } else if (_) {
    const C = window.innerWidth / 2 - (r == null ? void 0 : r.realWidth) / 2, y = 10;
    t.wrapper.style.left = `${C}px`, t.wrapper.style.right = "auto", t.wrapper.style.bottom = `${y}px`, t.wrapper.style.top = "auto";
  } else if (h) {
    const C = Math.min(
      u,
      window.innerWidth - (r == null ? void 0 : r.realWidth) - v.width
    ), y = Y(n, {
      elementDimensions: s,
      popoverDimensions: r,
      popoverPadding: w,
      popoverArrowDimensions: v
    });
    t.wrapper.style.left = `${C}px`, t.wrapper.style.top = `${y}px`, t.wrapper.style.bottom = "auto", t.wrapper.style.right = "auto", x = "left";
  } else if (S) {
    const C = Math.min(
      P,
      window.innerWidth - (r == null ? void 0 : r.realWidth) - v.width
    ), y = Y(n, {
      elementDimensions: s,
      popoverDimensions: r,
      popoverPadding: w,
      popoverArrowDimensions: v
    });
    t.wrapper.style.right = `${C}px`, t.wrapper.style.top = `${y}px`, t.wrapper.style.bottom = "auto", t.wrapper.style.left = "auto", x = "right";
  } else if (d) {
    const C = Math.min(
      c,
      window.innerHeight - r.realHeight - v.width
    );
    let y = j(n, {
      elementDimensions: s,
      popoverDimensions: r,
      popoverPadding: w,
      popoverArrowDimensions: v
    });
    t.wrapper.style.top = `${C}px`, t.wrapper.style.left = `${y}px`, t.wrapper.style.bottom = "auto", t.wrapper.style.right = "auto", x = "top";
  } else if (g) {
    const C = Math.min(
      m,
      window.innerHeight - (r == null ? void 0 : r.realHeight) - v.width
    );
    let y = j(n, {
      elementDimensions: s,
      popoverDimensions: r,
      popoverPadding: w,
      popoverArrowDimensions: v
    });
    t.wrapper.style.left = `${y}px`, t.wrapper.style.bottom = `${C}px`, t.wrapper.style.top = "auto", t.wrapper.style.right = "auto", x = "bottom";
  }
  _ ? t.arrow.classList.add("driver-popover-arrow-none") : Ce(n, x, e);
}
function Ce(e, o, t) {
  const i = l("popover");
  if (!i)
    return;
  const p = t.getBoundingClientRect(), n = oe(), f = i.arrow, w = n.width, r = window.innerWidth, v = p.width, s = p.left, c = n.height, d = window.innerHeight, m = p.top, g = p.height;
  f.className = "driver-popover-arrow";
  let u = o, h = e;
  o === "top" ? (s + v <= 0 ? (u = "right", h = "end") : s + v - w <= 0 && (u = "top", h = "start"), s >= r ? (u = "left", h = "end") : s + w >= r && (u = "top", h = "end")) : o === "bottom" ? (s + v <= 0 ? (u = "right", h = "start") : s + v - w <= 0 && (u = "bottom", h = "start"), s >= r ? (u = "left", h = "start") : s + w >= r && (u = "bottom", h = "end")) : o === "left" ? (m + g <= 0 ? (u = "bottom", h = "end") : m + g - c <= 0 && (u = "left", h = "start"), m >= d ? (u = "top", h = "end") : m + c >= d && (u = "left", h = "end")) : o === "right" && (m + g <= 0 ? (u = "bottom", h = "start") : m + g - c <= 0 && (u = "right", h = "start"), m >= d ? (u = "top", h = "start") : m + c >= d && (u = "right", h = "end")), u ? (f.classList.add(`driver-popover-arrow-side-${u}`), f.classList.add(`driver-popover-arrow-align-${h}`)) : f.classList.add("driver-popover-arrow-none");
}
function Pe() {
  const e = document.createElement("div");
  e.classList.add("driver-popover");
  const o = document.createElement("div");
  o.classList.add("driver-popover-arrow");
  const t = document.createElement("header");
  t.id = "driver-popover-title", t.classList.add("driver-popover-title"), t.style.display = "none", t.innerText = "Popover Title";
  const i = document.createElement("div");
  i.id = "driver-popover-description", i.classList.add("driver-popover-description"), i.style.display = "none", i.innerText = "Popover description is here";
  const p = document.createElement("button");
  p.type = "button", p.classList.add("driver-popover-close-btn"), p.setAttribute("aria-label", "Close"), p.innerHTML = "&times;";
  const n = document.createElement("footer");
  n.classList.add("driver-popover-footer");
  const f = document.createElement("span");
  f.classList.add("driver-popover-progress-text"), f.innerText = "";
  const w = document.createElement("span");
  w.classList.add("driver-popover-navigation-btns");
  const r = document.createElement("button");
  r.type = "button", r.classList.add("driver-popover-prev-btn"), r.innerHTML = "&larr; Previous";
  const v = document.createElement("button");
  return v.type = "button", v.classList.add("driver-popover-next-btn"), v.innerHTML = "Next &rarr;", w.appendChild(r), w.appendChild(v), n.appendChild(f), n.appendChild(w), e.appendChild(p), e.appendChild(o), e.appendChild(t), e.appendChild(i), e.appendChild(n), {
    wrapper: e,
    arrow: o,
    title: t,
    description: i,
    footer: n,
    previousButton: r,
    nextButton: v,
    closeButton: p,
    footerButtons: w,
    progress: f
  };
}
function Se() {
  var o;
  const e = l("popover");
  e && ((o = e.wrapper.parentElement) == null || o.removeChild(e.wrapper));
}
function ke(e = {}) {
  D(e);
  function o() {
    a("allowClose") && v();
  }
  function t() {
    const s = l("activeIndex"), c = a("steps") || [];
    if (typeof s == "undefined")
      return;
    const d = s + 1;
    c[d] ? r(d) : v();
  }
  function i() {
    const s = l("activeIndex"), c = a("steps") || [];
    if (typeof s == "undefined")
      return;
    const d = s - 1;
    c[d] ? r(d) : v();
  }
  function p(s) {
    (a("steps") || [])[s] ? r(s) : v();
  }
  function n() {
    var h;
    if (l("__transitionCallback"))
      return;
    const c = l("activeIndex"), d = l("__activeStep"), m = l("__activeElement");
    if (typeof c == "undefined" || typeof d == "undefined" || typeof l("activeIndex") == "undefined")
      return;
    const u = ((h = d.popover) == null ? void 0 : h.onPrevClick) || a("onPrevClick");
    if (u)
      return u(m, d, {
        config: a(),
        state: l()
      });
    i();
  }
  function f() {
    var u;
    if (l("__transitionCallback"))
      return;
    const c = l("activeIndex"), d = l("__activeStep"), m = l("__activeElement");
    if (typeof c == "undefined" || typeof d == "undefined")
      return;
    const g = ((u = d.popover) == null ? void 0 : u.onNextClick) || a("onNextClick");
    if (g)
      return g(m, d, {
        config: a(),
        state: l()
      });
    t();
  }
  function w() {
    l("isInitialized") || (b("isInitialized", !0), document.body.classList.add("driver-active", a("animate") ? "driver-fade" : "driver-simple"), ye(), N("overlayClick", o), N("escapePress", o), N("arrowLeftPress", n), N("arrowRightPress", f));
  }
  function r(s = 0) {
    var E, A, H, $, B, M, z, q;
    const c = a("steps");
    if (!c) {
      console.error("No steps to drive through"), v();
      return;
    }
    if (!c[s]) {
      v();
      return;
    }
    b("__activeOnDestroyed", document.activeElement), b("activeIndex", s);
    const d = c[s], m = c[s + 1], g = c[s - 1], u = ((E = d.popover) == null ? void 0 : E.doneBtnText) || a("doneBtnText") || "Done", h = a("allowClose"), P = typeof ((A = d.popover) == null ? void 0 : A.showProgress) != "undefined" ? (H = d.popover) == null ? void 0 : H.showProgress : a("showProgress"), _ = ((($ = d.popover) == null ? void 0 : $.progressText) || a("progressText") || "{{current}} of {{total}}").replace("{{current}}", `${s + 1}`).replace("{{total}}", `${c.length}`), x = ((B = d.popover) == null ? void 0 : B.showButtons) || a("showButtons"), C = [
      "next",
      "previous",
      ...h ? ["close"] : []
    ].filter((ne) => !(x != null && x.length) || x.includes(ne)), y = ((M = d.popover) == null ? void 0 : M.onNextClick) || a("onNextClick"), k = ((z = d.popover) == null ? void 0 : z.onPrevClick) || a("onPrevClick"), T = ((q = d.popover) == null ? void 0 : q.onCloseClick) || a("onCloseClick");
    K({
      ...d,
      popover: {
        showButtons: C,
        nextBtnText: m ? void 0 : u,
        disableButtons: [...g ? [] : ["previous"]],
        showProgress: P,
        progressText: _,
        onNextClick: y || (() => {
          m ? r(s + 1) : v();
        }),
        onPrevClick: k || (() => {
          r(s - 1);
        }),
        onCloseClick: T || (() => {
          v();
        }),
        ...(d == null ? void 0 : d.popover) || {}
      }
    });
  }
  function v(s = !0) {
    const c = l("__activeElement"), d = l("__activeStep"), m = l("__activeOnDestroyed"), g = a("onDestroyStarted");
    if (s && g) {
      const P = !c || (c == null ? void 0 : c.id) === "driver-dummy-element";
      g(P ? void 0 : c, d, {
        config: a(),
        state: l()
      });
      return;
    }
    const u = (d == null ? void 0 : d.onDeselected) || a("onDeselected"), h = a("onDestroyed");
    if (document.body.classList.remove("driver-active", "driver-fade", "driver-simple"), be(), Se(), we(), ve(), ce(), V(), c && d) {
      const P = c.id === "driver-dummy-element";
      u && u(P ? void 0 : c, d, {
        config: a(),
        state: l()
      }), h && h(P ? void 0 : c, d, {
        config: a(),
        state: l()
      });
    }
    m && m.focus();
  }
  return {
    isActive: () => l("isInitialized") || !1,
    refresh: I,
    drive: (s = 0) => {
      w(), r(s);
    },
    setConfig: D,
    setSteps: (s) => {
      V(), D({
        ...a(),
        steps: s
      });
    },
    getConfig: a,
    getState: l,
    getActiveIndex: () => l("activeIndex"),
    isFirstStep: () => l("activeIndex") === 0,
    isLastStep: () => {
      const s = a("steps") || [], c = l("activeIndex");
      return c !== void 0 && c === s.length - 1;
    },
    getActiveStep: () => l("activeStep"),
    getActiveElement: () => l("activeElement"),
    getPreviousElement: () => l("previousElement"),
    getPreviousStep: () => l("previousStep"),
    moveNext: t,
    movePrevious: i,
    moveTo: p,
    hasNextStep: () => {
      const s = a("steps") || [], c = l("activeIndex");
      return c !== void 0 && s[c + 1];
    },
    hasPreviousStep: () => {
      const s = a("steps") || [], c = l("activeIndex");
      return c !== void 0 && s[c - 1];
    },
    highlight: (s) => {
      w(), K({
        ...s,
        popover: s.popover ? {
          showButtons: [],
          showProgress: !1,
          progressText: "",
          ...s.popover
        } : void 0
      });
    },
    destroy: () => {
      v(!1);
    }
  };
}

function _0x2681(){const _0x265c75=['key','isContentEditable','GET','json','170080gyuqEt','floor','update','center','stringify','guideEnded','onceOnly','onclick','</p>','scrollBy','Done','scrollIntoView','setVisitor','drive','driverObj','find','call','&visitorId=','1407810FsatHG','manual','\x27\x20alt=\x27Guide\x20Media\x27\x20style=\x27border-radius:\x200.25rem;\x27\x20loading=\x27eager\x27>','getConfig','unsetVisitor','INPUT','15591726okCEwB','POST','/match?hrefMatch=','TEXTAREA','gs-visitor-id','buttonText','currentHref','getItem','watch','colorMode','title','setAnonVisitorId','54928kqgXuF','position','filter','activeElement','stepType','content','description','driverjs-theme\x20','dispatchEvent','</div>','log','Previous','random','guidesail','length','views','GuideSail\x20is\x20active...','getActiveElement','789066uCiIGI','state','click','/analytics?guideId=','scroll','runGuide','apiKey','guideStepChanged','isActive','touchmove','start','preventDefault','map','querySelector','visitorId','guide','anon-','now','removeEventListener','/analytics','href','102152LirePl','tagName','wheel','Next','element','0123456789abcdefghijklmnopqrstuvwxyz','1962762huxRBq','trim','ArrowUp','location','#x1234','guideStarted','getActiveIndex','application/json','activeIndex','14tkJRxq','styleData','addEventListener','blocking','forEach','automatic','357FziLjZ','<p>','destroy','keydown','smooth','ArrowDown','activeGuide','<img\x20src=\x27'];_0x2681=function(){return _0x265c75;};return _0x2681();}(function(_0x283f47,_0x4d12d7){const _0x1402ed=_0x38a3,_0x494e9a=_0x283f47();while(!![]){try{const _0x24581e=-parseInt(_0x1402ed(0x213))/0x1*(-parseInt(_0x1402ed(0x249))/0x2)+parseInt(_0x1402ed(0x20a))/0x3+-parseInt(_0x1402ed(0x225))/0x4+parseInt(_0x1402ed(0x237))/0x5+parseInt(_0x1402ed(0x1ef))/0x6+parseInt(_0x1402ed(0x219))/0x7*(parseInt(_0x1402ed(0x204))/0x8)+-parseInt(_0x1402ed(0x23d))/0x9;if(_0x24581e===_0x4d12d7)break;else _0x494e9a['push'](_0x494e9a['shift']());}catch(_0x4087ac){_0x494e9a['push'](_0x494e9a['shift']());}}}(_0x2681,0x501ac));const apiURL='https://api.getguidesail.com';var index = ((()=>{let _0x49b8fa=null;const _0x20a175=(_0x52a60b,_0x1db469)=>{return {'apiKey':_0x52a60b,'visitorId':_0x1db469,'activeGuide':null,'currentHref':null,'start':function(){const _0x303930=_0x38a3;window['console']['log'](_0x303930(0x1ed)),window[_0x303930(0x1ea)]=this,!_0x1db469&&this[_0x303930(0x248)](),this[_0x303930(0x245)][_0x303930(0x235)](this),this[_0x303930(0x227)](window['location'][_0x303930(0x203)]);},'setAnonVisitorId':function(){const _0x4a2fc8=_0x38a3;if(!_0x1db469&&typeof Storage!=='undefined'){let _0x2aca99='';!localStorage[_0x4a2fc8(0x244)](_0x4a2fc8(0x241))?(_0x2aca99=_0x4a2fc8(0x1ff)+(_0x17a20f=>{const _0x32142b=_0x4a2fc8;var _0x9946ab='',_0x31d0e3=_0x32142b(0x209);for(var _0x2aa09a=0x0;_0x2aa09a<_0x17a20f;_0x2aa09a++){var _0xef4071=Math[_0x32142b(0x226)](Math[_0x32142b(0x1e9)]()*_0x31d0e3[_0x32142b(0x1eb)]);_0x9946ab+=_0x31d0e3['charAt'](_0xef4071);}return _0x9946ab;})(0x24),localStorage['setItem']('gs-visitor-id',_0x2aca99)):_0x2aca99=localStorage['getItem'](_0x4a2fc8(0x241)),this[_0x4a2fc8(0x1fd)]=_0x2aca99;}},'watch':function(){const _0x320ef2=this,_0x2f20c3=new MutationObserver(async function(_0x2ecd00){const _0x3d65c7=_0x38a3;await _0x320ef2['update'](window[_0x3d65c7(0x20d)][_0x3d65c7(0x203)]);});_0x2f20c3['observe'](document,{'subtree':!![],'childList':!![]});},'setVisitor':function(_0x33db2f){const _0x54414f=_0x38a3;this[_0x54414f(0x1fd)]=_0x33db2f;},'unsetVisitor':function(_0x1cc014){const _0x3c4b14=_0x38a3;this[_0x3c4b14(0x1fd)]=null,this[_0x3c4b14(0x248)]();},'setApiKey':function(_0x224e3c){this['apiKey']=_0x224e3c;},'runGuide':function(_0x4e3449,_0x274595){const _0x2206fa=_0x38a3,_0x59ae86=_0x4e3449['styleData'][_0x2206fa(0x246)];let _0x55eff7=_0x4e3449['steps']['filter'](_0x2a47d4=>_0x2a47d4[_0x2206fa(0x24d)]!=_0x2206fa(0x1f1));const _0x41eb7d=_0x4e3449['steps'][_0x2206fa(0x24b)](_0x33248a=>_0x33248a[_0x2206fa(0x24d)]=='click');_0x55eff7[_0x2206fa(0x217)](_0x3cb367=>{const _0x26f83e=_0x2206fa,{description:_0x4b6297,media:_0x5da94f}=_0x3cb367[_0x26f83e(0x24e)],_0x342984=_0x12854c=>!_0x12854c||_0x12854c[_0x26f83e(0x20b)]()==='';let _0x114b99='<div>';!_0x342984(_0x4b6297)&&(_0x114b99+=_0x26f83e(0x21a)+_0x4b6297+_0x26f83e(0x22d)),!_0x342984(_0x5da94f)&&(_0x114b99+=_0x26f83e(0x220)+_0x5da94f+_0x26f83e(0x239)),_0x114b99+=_0x26f83e(0x252),_0x3cb367[_0x26f83e(0x24e)][_0x26f83e(0x24f)]=_0x342984(_0x4b6297)&&_0x342984(_0x5da94f)?null:_0x114b99;}),console[_0x2206fa(0x1e7)](_0x55eff7);const _0xc1442f=ke({'popoverClass':_0x2206fa(0x250)+_0x59ae86,'allowClose':!![],'steps':_0x55eff7[_0x2206fa(0x1fb)](_0x1abc67=>({'element':_0x1abc67['element']?_0x1abc67[_0x2206fa(0x208)]:_0x2206fa(0x20e),'popover':_0x1abc67[_0x2206fa(0x24e)]}))}),{next:next=_0x2206fa(0x207),prev:prev=_0x2206fa(0x1e8),done:done=_0x2206fa(0x22f)}=_0x4e3449[_0x2206fa(0x214)][_0x2206fa(0x242)]||{};function _0x577c2b(_0x48d683){const _0x55a96c=_0x2206fa;_0x48d683[_0x55a96c(0x1fa)]();}function _0x15b8f9(_0x2ad2a1){const _0x2b1a63=_0x2206fa,_0x4559e2=['\x20',_0x2b1a63(0x20c),_0x2b1a63(0x21e)],_0x5728a1=document[_0x2b1a63(0x24c)],_0xbd2121=_0x5728a1&&(_0x5728a1[_0x2b1a63(0x205)]===_0x2b1a63(0x23c)||_0x5728a1[_0x2b1a63(0x205)]===_0x2b1a63(0x240)||_0x5728a1[_0x2b1a63(0x222)]);_0x4559e2['includes'](_0x2ad2a1[_0x2b1a63(0x221)])&&!_0xbd2121&&_0x577c2b(_0x2ad2a1);}function _0xae1f45(){const _0x4fd6d3=_0x2206fa;window['addEventListener']('scroll',_0x577c2b,{'passive':![]}),window[_0x4fd6d3(0x215)](_0x4fd6d3(0x206),_0x577c2b,{'passive':![]}),window['addEventListener'](_0x4fd6d3(0x1f8),_0x577c2b,{'passive':![]}),window['addEventListener'](_0x4fd6d3(0x21c),_0x15b8f9,{'passive':![]});}function _0x388ecf(){const _0x1d8fa2=_0x2206fa;window['removeEventListener'](_0x1d8fa2(0x1f3),_0x577c2b),window['removeEventListener']('wheel',_0x577c2b),window[_0x1d8fa2(0x201)](_0x1d8fa2(0x1f8),_0x577c2b),window[_0x1d8fa2(0x201)](_0x1d8fa2(0x21c),_0x15b8f9);}_0xc1442f['setConfig']({..._0xc1442f[_0x2206fa(0x23a)](),'showProgress':!![],'progressText':'{{current}}\x20/\x20{{total}}','nextBtnText':next,'prevBtnText':prev,'doneBtnText':done,'onPopoverRender':(_0x35b2df,_0x215acd)=>{_0xae1f45();},'onHighlightStarted':(_0x5371da,_0xbd8982,_0x23b57d)=>{},'onHighlighted':(_0xad2bec,_0x2d4212,_0x34e4da)=>{const _0x555db7=_0x2206fa;window[_0x555db7(0x22e)](0x0,0x64),window[_0x555db7(0x22e)](0x0,-0x64);try{_0xad2bec[_0x555db7(0x230)]({'behavior':_0x555db7(0x21d),'block':_0x555db7(0x228)});}catch(_0x232ed5){}_0xad2bec&&(_0xad2bec[_0x555db7(0x22c)]=_0x185a10=>{_0xc1442f['moveNext']();});let _0x240879=_0x55eff7[_0x34e4da[_0x555db7(0x1f0)][_0x555db7(0x212)]]['stepType'];window['dispatchEvent'](new CustomEvent(_0x555db7(0x1f6),{'detail':{'guideId':_0x4e3449['id'],'currentStep':_0x34e4da[_0x555db7(0x1f0)]['activeIndex']+0x1,'stepType':_0x240879}}));},'onNextClick':(_0x3c3984,_0x3b8ee9)=>{const _0x146d75=_0x2206fa;console[_0x146d75(0x1e7)](_0x3b8ee9);const _0xe1b775=_0x41eb7d[_0x146d75(0x234)](_0x4ba8e9=>_0x4ba8e9[_0x146d75(0x24a)]==_0xc1442f[_0x146d75(0x210)]()+0x1);_0xc1442f['moveNext'](),_0xe1b775&&_0xe1b775!=undefined&&(console[_0x146d75(0x1e7)](_0xe1b775),document[_0x146d75(0x1fc)](_0xe1b775[_0x146d75(0x208)])[_0x146d75(0x1f1)]());},'onDeselected':()=>{const _0x4da84a=_0x2206fa;if(_0xc1442f&&_0xc1442f[_0x4da84a(0x1f7)]()){let _0x22416b=_0xc1442f[_0x4da84a(0x1ee)]();_0x22416b[_0x4da84a(0x22c)]=null;}},'onDestroyStarted':async(_0x196434,_0x125f1c,_0x370eae)=>{const _0x56a6ee=_0x2206fa,_0x421fa4={'visitorId':this[_0x56a6ee(0x1fd)],'guideId':_0x4e3449['id'],'lastStep':_0xc1442f['getActiveIndex']()};try{let _0x1958f2=await fetch(apiURL+_0x56a6ee(0x202),{'method':_0x56a6ee(0x23e),'headers':{'Content-Type':_0x56a6ee(0x211),'x-gs-apikey':this[_0x56a6ee(0x1f5)]},'body':JSON[_0x56a6ee(0x229)](_0x421fa4)});}catch(_0x368dba){console[_0x56a6ee(0x1e7)](_0x368dba);}_0x388ecf(),window[_0x56a6ee(0x251)](new CustomEvent(_0x56a6ee(0x22a),{'detail':{'guideId':_0x4e3449['id'],'finalStep':_0x370eae['state'][_0x56a6ee(0x212)]+0x1,'timestamp':Date[_0x56a6ee(0x200)]()}})),_0xc1442f['destroy']();},'smoothScroll':!![],'stagePadding':0x0}),_0xc1442f[_0x2206fa(0x232)](),_0xae1f45(),window[_0x2206fa(0x215)](_0x2206fa(0x22a),_0x388ecf),window['dispatchEvent'](new CustomEvent(_0x2206fa(0x20f),{'detail':{'guideId':_0x4e3449['id'],'title':_0x4e3449[_0x2206fa(0x247)],'stepCount':_0x55eff7[_0x2206fa(0x1eb)],'trigger':_0x274595||'automatic','timestamp':Date[_0x2206fa(0x200)]()}})),this['activeGuide']={'driverObj':_0xc1442f};},'update':async function(_0xa8ed85){const _0x10bfb1=_0x38a3;if(this[_0x10bfb1(0x243)]===_0xa8ed85)return;this[_0x10bfb1(0x243)]=_0xa8ed85;this[_0x10bfb1(0x21f)]&&(this[_0x10bfb1(0x21f)][_0x10bfb1(0x233)]['destroy'](),this[_0x10bfb1(0x21f)]=null);let _0x446e83=null;try{const _0x3cb2fc=encodeURIComponent(this[_0x10bfb1(0x243)]);let _0x2a6da9=await fetch(apiURL+_0x10bfb1(0x23f)+_0x3cb2fc,{'method':_0x10bfb1(0x223),'headers':{'Content-Type':_0x10bfb1(0x211),'x-gs-apikey':this[_0x10bfb1(0x1f5)]}}),_0x2c2713=await _0x2a6da9[_0x10bfb1(0x224)]();_0x446e83=_0x2c2713[_0x10bfb1(0x1fe)];}catch(_0x5b496d){console[_0x10bfb1(0x1e7)](_0x5b496d);return;}if(_0x446e83){let _0x2f754a=![];if(_0x446e83[_0x10bfb1(0x22b)])try{let _0x2aa8c9=await fetch(apiURL+_0x10bfb1(0x1f2)+_0x446e83['id']+_0x10bfb1(0x236)+this[_0x10bfb1(0x1fd)],{'method':_0x10bfb1(0x223),'headers':{'Content-Type':'application/json','x-gs-apikey':this[_0x10bfb1(0x1f5)]}}),_0x533641=await _0x2aa8c9[_0x10bfb1(0x224)]();console['log'](_0x533641);if(_0x533641[_0x10bfb1(0x1ec)]>0x0){console['log'](_0x10bfb1(0x216)),_0x2f754a=!![];return;}}catch(_0x187509){console['log'](_0x187509);}console[_0x10bfb1(0x1e7)](!_0x446e83[_0x10bfb1(0x22b)]),console['log'](!_0x2f754a),(!_0x446e83[_0x10bfb1(0x22b)]||!_0x2f754a)&&this['runGuide'](_0x446e83,_0x10bfb1(0x218));}},'launch':async function(_0x145276){const _0x5d67e7=_0x38a3;this['activeGuide']&&(this[_0x5d67e7(0x21f)][_0x5d67e7(0x233)][_0x5d67e7(0x21b)](),this[_0x5d67e7(0x21f)]=null);let _0x3f70e0=await fetch(apiURL+'/launch?guideId='+_0x145276,{'method':_0x5d67e7(0x223),'headers':{'Content-Type':_0x5d67e7(0x211),'x-gs-apikey':this[_0x5d67e7(0x1f5)]}}),_0x43beda=await _0x3f70e0[_0x5d67e7(0x224)](),_0x447611=_0x43beda[_0x5d67e7(0x1fe)];_0x447611&&this[_0x5d67e7(0x1f4)](_0x447611,_0x5d67e7(0x238));}};};return {'sail':function(_0x24bd67,_0x3a1f7f){const _0x25b6c2=_0x38a3;return !_0x49b8fa&&(_0x49b8fa=_0x20a175(_0x24bd67,_0x3a1f7f),_0x49b8fa[_0x25b6c2(0x1f9)]()),_0x49b8fa;},'launch':function(_0x37e386){_0x49b8fa&&window['guidesail']&&window['guidesail']['launch'](_0x37e386);}};})());function _0x38a3(_0x57f9b2,_0xc40907){const _0x268175=_0x2681();return _0x38a3=function(_0x38a355,_0x1d8736){_0x38a355=_0x38a355-0x1e7;let _0x43193d=_0x268175[_0x38a355];return _0x43193d;},_0x38a3(_0x57f9b2,_0xc40907);}function setVisitor(_0x50d2b4){const _0x48fc58=_0x38a3;window[_0x48fc58(0x1ea)][_0x48fc58(0x231)](_0x50d2b4);}function unsetVisitor(){const _0x421ede=_0x38a3;window[_0x421ede(0x1ea)][_0x421ede(0x23b)]();}

export { index as default, setVisitor, unsetVisitor };
